module.exports = require("./tr-TR");